import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { Pages } from '@shared/constants';

import { DataService } from '../services/data.service';

export const retailerRedirectionGuard: CanMatchFn = () => {
  const router: Router = inject(Router);
  const dataService: DataService = inject(DataService);

  const availablePages: string[] = dataService.config().pages.availablePages;

  if (availablePages.includes(Pages.LOGIN)) {
    return router.parseUrl(Pages.LOGIN);
  }
  return router.parseUrl(Pages.SORRY);
};
